import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import useFetchData from "repo/get";
import { InputText } from "primereact/inputtext";

const CardDevolucao = () => {
    const [filteredData, setFilteredData] = useState([]);
    const baseSelect = localStorage.getItem("baseSelected") || "";

    const { data, loading } = useFetchData(
        `api/devolucao/findByDevolucao/${baseSelect}?inbase=true&devolvido=true&finalizado=false`
    );
    const [globalFilterValue, setGlobalFilterValue] = useState("");

    useEffect(() => {
        if (data && Array.isArray(data)) {
            const formattedData = data.map((item) => ({
                nome: item.codigo.codigo || "Desconhecido",
                cidade: item.codigo.cidadeLogistico || "Desconhecido",
                status: item.codigo.statusLogistico || "Desconhecido",
                cep : item.codigo.cepLogistico || "Desconhecido",
                inbase: item.inbase || false,
                devolvido: "Em Transito",
                entregador: item.entregador.nome || "Desconhecido",
                motorista: item.motorista.nome || "Desconhecido",
                finalizado: item.finalizado || false,
                data: item.dataRecebido ? item.dataRecebido.replace("T", " ").split(".")[0] : new Date().toISOString().replace("T", " ").split(".")[0],
            }));

            setFilteredData(formattedData.filter((item) => item.inbase === true && item.finalizado === false));

        }
    }, [data]);

    const onGlobalFilterChange = (e) => {
        const value = e.target.value || "";
        setGlobalFilterValue(value);
    };

    const header = (
        <div className="table-header flex flex-col md:flex-row   justify-between items-center">
            <span className="p-input-icon-left">
                <InputText
                    type="search"
                    value={globalFilterValue}
                    onChange={onGlobalFilterChange}
                    placeholder="Buscar..."
                />
            </span>
            <h4 className="text-2xl uppercase font-bold text-blueGray-700 ml-auto">
                {filteredData.length} Pacotes
            </h4>
        </div>
    );

    return (
        <div>

            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white p-6">

                {/* DataTable */}
                <DataTable
                    value={filteredData}
                    paginator
                    rows={30}
                    stripedRows
                    rowsPerPageOptions={[5, 10, 30, 50, 100,300,1000, 99999]}
                    globalFilterFields={['nome']}
                    filters={{ global: { value: globalFilterValue, matchMode: "contains" } }}
                    header={header}
                    emptyMessage={loading ? "Carregando dados..." : "Nenhum resultado encontrado."}
                >
                    <Column
                        field="nome"
                        header="Codigo"
                        sortable
                        style={{ minWidth: "12rem", fontSize: "13px" }}
                        body={(rowData) => (
                            <span data-label={rowData.nome} style={{ userSelect: "text" }}>
                                {rowData.nome}
                            </span>
                        )}
                    />

                    <Column field="entregador" header="Entregador" sortable style={{ minWidth: "12rem", fontSize: "13px" }} />
                    <Column field="motorista" header="Motorista" sortable style={{ minWidth: "12rem", fontSize: "13px" }} />
                    <Column field="cidade" header="Cidade" sortable style={{ minWidth: "12rem", fontSize: "13px" }} />
                    <Column field="status" header="Status" sortable style={{ minWidth: "12rem", fontSize: "13px" }} />
                    <Column field="cep" header="Cep" sortable style={{ minWidth: "12rem", fontSize: "13px" }} />
                    <Column field="data" header="Data da Recebimento" sortable style={{ minWidth: "12rem", fontSize: "13px" }} />

                </DataTable>
            </div> </div>
    );
};

export default CardDevolucao;
